import { defineInterface } from '../Interface.js';
/**
 * The environment variables interface.
 */
export const EnvVariables = defineInterface({
    name: 'EnvVariables',
    default: () => process.env,
});
//# sourceMappingURL=EnvVariables.js.map